import { render } from "./LegalNotice.vue?vue&type=template&id=abeac28e"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"

import "./LegalNotice.vue?vue&type=style&index=0&id=abeac28e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__